/*@flow*/
import styled from '@emotion/styled';

export default (styled.div(`
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 5px;
  background: linear-gradient(#ddd, transparent);
  pointer-events: none;
  z-index: 99;
  display: none;
`): any);
